import debug from 'debug';
import BaseClass from 'Global/Shared/Components/BaseComponent/BaseClass';
import Authenticate from 'Minetilbud/Shared/Components/Api/Authenticate';
import ValidateForm from '../validate-form/validate-form';

const log = debug('LoginOverlay');

class LoginOverlay extends BaseClass {
	
	/**
	 * @param {Element} element the element that contains the form
	 * @param {string} [redirectUrl] 
	 */
	constructor(element, redirectUrl) {
		super(element)
		this.redirectUrl = redirectUrl;

		this.passwordKeydownEvent = this.passwordKeydownHandler.bind(this);
		this.submitButtonEvent = this.submitButtonHandler.bind(this);
		
		this.initialize();
	}

	eventListeners() {
		this.dom.submitButton.addEventListener('click', this.submitButtonEvent, true);
		this.dom.password.addEventListener('keydown', this.passwordKeydownEvent, false);
	}

	initialize() {
		this.initDomCache();
		this.setup();
		this.eventListeners();
	}

	async login() {
		this.dom.submitButton.classList.add('is-waiting');

		try {
			log('login() - authenticating');
			const authenticate = new Authenticate();
			const response = await authenticate.Login({
				password: this.dom.password.value,
				persistent: false,
				username: this.dom.username.value
			});

			log('login() - success', response);

			this.redirect();
		} catch (error) {
			this.dom.errorMessage.classList.remove('u-is-hidden');
			this.dom.submitButton.classList.remove('is-waiting')
			log('login() - error', error);
		}
	}

	passwordKeydownHandler(event) {
		if (event.keyCode === 13) {
			this.submitButtonHandler(event);
		}
	}

	redirect() {
		if (this.redirectUrl) {
			window.location = this.redirectUrl;
		}
	}

	setup() {
		this.validateForm = new ValidateForm(this.dom.form);
	}

	/**
	 * @param {Event} event 
	 */
	 async submitButtonHandler(event) {
		event.preventDefault();
		const isValid = await this.validateForm.validateAllFields();

		log('submitButtonHandler() - isValid', isValid);

		if (this.dom.submitButton.classList.contains('is-waiting')) return;

		if (isValid) {
			this.login();
		}
	}
}

export default LoginOverlay;
